<!-- M1D DR007-->
<template>
  <div class="pieline-wrap">
    <vue-loading 
      v-if="isshowloading"
      style="margin-top: 60px;"
      type="bars" 
      color="#d9544e" 
      :size="{ width: '50px', height: '50px' }"
    ></vue-loading>
    <div class="tabs">
      <div
        v-for="(item, i) in tab.text"
        :ref="'pal' + i"
        :class="['tab', i === tab.index  && 'active']"
        :key=i
        @click="tab.index = i;changetab()"
      >{{item}}</div>
      <div :ltip="szmessage" class="tips"></div>
    </div>
    
    <ChartTpl
      key="hSValues0"
      :enableResize='true'
      :elementId='"pielineCircle"'
      :width='"100%"'
      :height='"120px"'
      :option='circleOption'
      :originData='circleData'
    ></ChartTpl>
  
    <ChartTpl
        ref="pieline0"
        v-show="tab.index === 0"
        :enableResize='true'
        :firstTooltip='true'
        :elementId='"pieline0"'
        :width='"100%"'
        :height='"248px"'
        :option='line1Option'
        :originData='lineData'
      ></ChartTpl>

    <template v-if="alreadyLoad1">
      <ChartTpl
        v-show="tab.index === 1"
        ref="pieline1"
        :elementId='"pieline1"'
        :enableResize='true'
        :firstTooltip='true'
        :width='"100%"'
        :height='"248px"'
        :option='line2Option'
        :originData='line2Data'
      ></ChartTpl>
    </template>
      
  </div>
</template>

<script>
import ChartTpl from '@/components/ChartTpl.vue';
import { VueLoading } from 'vue-loading-template';

export default {
  name: "PieAndLine",
  components: {
    ChartTpl,
    VueLoading
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    M1:{
      type: Object,
      default: function () {
        return {}
      }
    },
    DR007:{
      type: Object,
      default: function () {
        return {}
      }
    },
    M1Series:{
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      tab: {
        index: 0,
        text: ["M1", "DR007"]
      },
      szmessage: 'M1：狭义货币（M1）=流通中的现金+支票存款（以及转账信用卡存款），M1反映居民和企业资金松紧变化，是经济周期波动的先行指标',
      circleOption: {},
      circleData:[],
      line1Option: {},
      lineData: [],
      line2Option: {},
      line2Data: [],
      DR007Series:[],
      alreadyLoad1: false,
      isshowloading: false,
    };
  },
  watch: {
    'tab.index':{
      handler(newvalue, oldvalue){
        let alreadyLoadStr = 'alreadyLoad'+newvalue;
        let getDataStr = 'getData'+newvalue;

        if (newvalue !== 0) {
          if(!this[alreadyLoadStr]) this[getDataStr]();
          this[alreadyLoadStr] = true;
        }
        setTimeout(()=>{
          this.$refs['pieline'+newvalue].resize();
        })
      }
    },
    M1Series: {
      handler(newvalue, oldvalue){
        this.init();
      }
    },
    DR007Series:{
      handler(newvalue, oldvalue){
        this.initLine2();
      }
    }
  },
  mounted() {
    this.report()
    LTip.width = 200;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();

    if(!this.M1Series.length) return;
    this.init();
  },
  methods: {
    report () {
      let ta = [{ id: 'pcweb_hgdata_m1' }, { id: 'pcweb_hgdata_dr007' }]
      for (let i = 0; i < 2; i++) {
        let elm = this.$refs['pal'+i][0]
        TA.logElementClick(elm, ta[i])
      }
    },
    changetab() {
      if(this.tab.index == 0)
      {
        this.szmessage = 'M1：狭义货币（M1）=流通中的现金+支票存款（以及转账信用卡存款），M1反映居民和企业资金松紧变化，是经济周期波动的先行指标'
      }
      if(this.tab.index ==1)
      {
        this.szmessage = 'DR007：银行间市场存款类机构以利率债为质押的7天回购利率。折线图的DR007为31日移动平均数'
      }  
    },
    getData1(){
      this.isshowloading = true;
      this.$api.blockAPI
        .getDR007Series()
        .then(res => {
          if (res.code === 0) {
            this.DR007Series = res.data.DR007Series;
            this.isshowloading = false;
          }
        })
        .catch(e => {});
    },
    initCircle(){
      let M1 = this.M1;
      let DR007 = this.DR007;
      this.circleOption = this.$chartConfigs.doubleCircle();
      this.circleOption.data[0] = {
        originData: [{
          min: 0,
          max: 1,
          title: 'M1同比',
          values: [
            {
              value: M1.percentile,
              show: M1.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: 'DR007',
          values: [
            {
              value: DR007.value >= 2.8 ? 0.75:(DR007.value<2.4?0.25:0.45),
              show: DR007.value 
            }
          ]
        }]
      };

      this.circleData = this.circleOption.data;
    },
    initLine(){
      this.line1Option = this.$chartConfigs.line1NoDataZoom({
          name:'M1同比', 
          lineColor: this.$chartConfigs.projectColors.blue,
          dataKey:'M1'
      });
      this.lineData = [{
          originData: this.M1Series
        }]
    },
    initLine2(){
      this.line2Option = this.$chartConfigs.markLeftToRightArea({
        line1:{
          name: 'DR007',
          lineColor: this.$chartConfigs.projectColors.blue,
          dataKey: 'DR007'
        },
        line2:{
          name: '上证指数',
          lineColor: this.$chartConfigs.projectColors.grey,
          dataKey: 'SH_price'
        },
        markLine: [2.4, 2.8],
        markArea: [2.4, 2.8],
        tooltip: 'getJudge2'
      });

      this.line2Data = [{
        originData: this.DR007Series
      }]
    },
    init(){
      this.initLine();
      this.initCircle();
    }
  }
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
</style>
<style lang="scss" scoped>
.pieline-wrap{
  font-size: 14px;
}
.tabs {
  display: flex;
  margin-bottom: 10px;
  flex: 0 0 auto;
  align-items: center;
  /* font-weight: 700; */
}
.tab {
  border: 1px solid #3b3c41;
  padding: 2px 12px;
  margin-left: -1px;
  cursor: pointer;
}
.tab.active {
  background: #3b3c41;
  color: #fff;
  cursor: default;
}
.select-style {
  color: #ffffff !important;
  background-color: #3b3c41;
}
.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  vertical-align: middle;
  margin-left:10px;
  width:24px;
  height: 16px;
}
.vue-loading {
  position: absolute;
  top: 50%;
  left: 40%;
  z-index: 9999;
}
</style>
